/**
 * Copyright © 2026 Adnuntius AS.
 *
 * ngx-translate compatibility with the previous angular-translate catalog:
 * - Resolve `@:other.key` aliases
 * - When a key lands on a namespace object, use the self-key shortcut
 *   (e.g. lineItem → lineItem.lineItem) the way angular-translate's flatObject did
 */
import {Injectable} from '@angular/core';
import {TranslateDefaultParser} from '@ngx-translate/core';

@Injectable()
export class AdnTranslateParser extends TranslateDefaultParser {
  getValue(target: any, key: string): any {
    return this.resolveValue(target, key, super.getValue(target, key), new Set<string>([key]));
  }

  private resolveValue(root: any, key: string, value: any, seen: Set<string>): any {
    if (typeof value === 'string' && value.indexOf('@:') === 0) {
      const ref = value.substring(2);
      if (seen.has(ref)) {
        return undefined;
      }
      seen.add(ref);
      return this.resolveValue(root, ref, super.getValue(root, ref), seen);
    }

    if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
      const leaf = key && key.indexOf('.') > -1 ? key.substring(key.lastIndexOf('.') + 1) : key;
      if (leaf && typeof value[leaf] !== 'undefined') {
        const selfKey = key + '.' + leaf;
        if (seen.has(selfKey)) {
          return undefined;
        }
        seen.add(selfKey);
        return this.resolveValue(root, selfKey, value[leaf], seen);
      }
      return undefined;
    }

    return value;
  }
}
